import routesReducer from './slice';

export default routesReducer;

export * from './data';
export * from './selectors';
export * from './slice';
